import { render } from "./AddItem.vue?vue&type=template&id=e8e8e86e&scoped=true"
import script from "./AddItem.vue?vue&type=script&lang=js"
export * from "./AddItem.vue?vue&type=script&lang=js"

import "./AddItem.vue?vue&type=style&index=0&id=e8e8e86e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8e8e86e"]])

export default __exports__